import React, { useState } from 'react';
import Select from 'react-select';

// Material UI
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

// Component
import { IFormOption } from '../../_core/_ui/forms.component';
import { PlayerRankingReportGraphQL } from '../../Report/PlayerRankingReport/player-ranking-report.graphql';
import { SkillComparisonReportGraphQL } from '../../Report/SkillComparisonReport/skill-comparison-report.graphql';
import { SectionWrapper } from '../../_core/_ui/structure.components';
import { ReportCardAvailabilityPanel } from '../../ReportCardAccess/report-card-availability-panel.component';
import { useCompanyHasReportCards, useCompanySportTerminology } from '../../../lib/stores/company.store';
import { SportTerminology } from '../../../lib/types';

interface IReports {
  ageGroup: IAgeGroup;
}

const REPORT_COMPONENTS: { [key: string]: any } = {
  RANKING: PlayerRankingReportGraphQL,
  SKILL: SkillComparisonReportGraphQL
}

export const Reports: React.FC<IReports> = ({ ageGroup }) => {
  const hasReportCards = useCompanyHasReportCards()
  const termLookup = useCompanySportTerminology();

  const reportOptions: IFormOption[] = [
    { value: 'RANKING', label: termLookup[SportTerminology.ATHLETE] + ' Ranking' },
    { value: 'SKILL', label: termLookup[SportTerminology.METRIC] + ' Comparison'}
  ];
  const [activeReportOption, setActiveReportOption] = useState(reportOptions[0]);
  const Component = REPORT_COMPONENTS[activeReportOption.value];

  const [goalieFilter, setGoalieFilter] = useState<'goalie' | 'other'>('other');

  return (
    <>
      {hasReportCards && (
        <Grid item xs={12}>
          <ReportCardAvailabilityPanel ageGroup={ageGroup} />
        </Grid>
      )}
      <Box display="flex" alignItems="center" mb={2} style={{ gap: '1rem' }}>
        <Box width="200px">
          <Select
            options={reportOptions}
            defaultValue={activeReportOption}
            onChange={option => option && setActiveReportOption(option)}
          />
        </Box>
        <Box width="200px">
          <Select
            options={[
              { value: 'other', label: "Skaters" },
              { value: 'goalie', label: "Goalies"}
            ]}
            defaultValue={{ value: 'other', label: "Skaters" }}
            onChange={option => option && setGoalieFilter(option.value as 'goalie' | 'other')}
          />
        </Box>
      </Box>
      <SectionWrapper>
        <Component ageGroup={ageGroup} goalieFilter={goalieFilter} />
      </SectionWrapper>
    </>
  )
};

